import type { RootState } from 'store';
import encoderStatusSlice from './slice';

export function getEncoderStatus(state: RootState, { assetType }: { assetType: string }) {
    return state[encoderStatusSlice.name]?.[assetType];
}
